import { LoadingContext } from "../Context";
import {
  LandingBanner,
  LandingRecentlyAlbums,
  LandingRecentlyPosts,
} from "../Components/Landing";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { GalleryType, PostListType, TeamType } from "../Structures";
import {
  TransactionGetBlog,
  TransactionGetGallery,
  TransactionGetTeamMembers,
} from "../Services/Transactions";
import { useScrollTop } from "../Hooks";

const Landing = () => {
  const { setLoading } = useContext(LoadingContext);

  // ========================================================================================================================

  const [posts, setPosts] = useState<PostListType[]>([]);
  const [albums, setAlbums] = useState<GalleryType[]>([]);
  const [teamMembers, setTeamMembers] = useState<TeamType[]>([]);

  // ========================================================================================================================

  useScrollTop();

  // ========================================================================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetBlog()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setPosts((res.data || []).slice(0, 4));
        }
      })
      .finally(() => setLoading(false));
    TransactionGetGallery()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setAlbums((res.data || []).slice(0, 4));
        }
      })
      .finally(() => setLoading(false));
    TransactionGetTeamMembers()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          if (res.data) {
            setTeamMembers((res.data || []));
          }
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ========================================================================================================================

  return (
    <Fragment>
      <LandingBanner />

      <div className="position-relative mt-5">
        {posts.length ? (
          <LandingRecentlyPosts title="تازه‌ترین اخبار" data={posts} />
        ) : null}
        {albums.length ? (
          <LandingRecentlyAlbums title="تازه‌ترین گالری" data={albums} />
        ) : null}
      </div>

      <div className="container mt-4">
        <h3 className="mb-4 fw-bold">
          <i className="bi bi-person-fill me-2"></i>
          مسئولین
        </h3>
        <div className="row justify-content-center mb-4 g-4">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-4 col-lg-3">
              <div className="text-center mx-auto">
                <div className="avatar avatar-xxl mb-2 mx-auto">
                  <img
                    className="avatar-img rounded-circle"
                    src={member.image}
                    alt={member.name}
                  />
                </div>
                <h5>{member.name}</h5>
                <p className="m-0">{member.job}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default Landing;
